import { create } from 'zustand';
import type { User } from '@dishly/shared';

const STORAGE_KEY = 'dishly-user';

function readCachedUser(): User | null {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) ?? 'null') as User | null;
  } catch {
    return null;
  }
}

interface SessionState {
  user: User | null;
  /** False until we know whether someone is logged in. */
  ready: boolean;
}

const cached = readCachedUser();

/**
 * The signed-in user. Cached in localStorage so the app knows who you are
 * when it starts offline; refreshed from the server on start-up.
 */
export const useSession = create<SessionState>(() => ({ user: cached, ready: cached !== null }));

export function setSessionUser(user: User | null): void {
  try {
    if (user) localStorage.setItem(STORAGE_KEY, JSON.stringify(user));
    else localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Storage can be unavailable (private mode); the in-memory state still works.
  }
  useSession.setState({ user, ready: true });
}

export const currentUserId = () => useSession.getState().user?.id ?? null;
